import React from "react";

export const NotFound = () => {
  return <div>NotFound</div>;
};

export default NotFound;
